// Branch and Stock Handover API Services
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://cornblissbackend-arerbqbwc5cmcufh.canadacentral-01.azurewebsites.net/api';

export const branchAPI = {
  // Branch Operations
  getAllBranches: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/branch`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch branches');
      return await response.json();
    } catch (error) {
      console.error('Error fetching branches:', error);
      throw error;
    }
  },

  getBranchById: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/branch/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch branch');
      return await response.json();
    } catch (error) {
      console.error('Error fetching branch:', error);
      throw error;
    }
  },

  addBranch: async (branchData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/branch`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(branchData),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to add branch');
      }
      return await response.json();
    } catch (error) {
      console.error('Error adding branch:', error);
      throw error;
    }
  },

  updateBranch: async (id, branchData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/branch/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(branchData),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update branch');
      }
      return await response.json();
    } catch (error) {
      console.error('Error updating branch:', error);
      throw error;
    }
  },

  deleteBranch: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/branch/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to delete branch');
      }
      return await response.json();
    } catch (error) {
      console.error('Error deleting branch:', error);
      throw error;
    }
  },

  getBranchStockSummary: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/branch/${id}/stock-summary`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch branch stock summary');
      return await response.json();
    } catch (error) {
      console.error('Error fetching branch stock summary:', error);
      throw error;
    }
  },
};

export const stockHandoverAPI = {
  // Stock Handover Operations
  getAllHandovers: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/stockhandover`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch stock handovers');
      return await response.json();
    } catch (error) {
      console.error('Error fetching stock handovers:', error);
      throw error;
    }
  },

  getHandoverById: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stockhandover/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch stock handover');
      return await response.json();
    } catch (error) {
      console.error('Error fetching stock handover:', error);
      throw error;
    }
  },

  getHandoversByBranch: async (branchId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stockhandover/branch/${branchId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Failed to fetch branch handovers');
      return await response.json();
    } catch (error) {
      console.error('Error fetching branch handovers:', error);
      throw error;
    }
  },

addHandover: async (handoverData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/stockhandover`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(handoverData),
    });
    if (!response.ok) {
      const error = await response.json();
      console.error('Backend validation error:', error); // 👈 add this
      throw new Error(error.message || 'Failed to add stock handover');
    }
    return await response.json();
  } catch (error) {
    console.error('Error adding stock handover:', error);
    throw error;
  }
},

  updateHandover: async (id, handoverData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stockhandover/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(handoverData),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update stock handover');
      }
      return await response.json();
    } catch (error) {
      console.error('Error updating stock handover:', error);
      throw error;
    }
  },

  deleteHandover: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/stockhandover/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to delete stock handover');
      }
      return await response.json();
    } catch (error) {
      console.error('Error deleting stock handover:', error);
      throw error;
    }
  },
};
